import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8d0e7cf6")

_pushScopeId("data-v-8d0e7cf6")
const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { class: "p-float-label kn-material-input" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Tag = _resolveComponent("Tag")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    ref: "dt",
    value: _ctx.functions,
    selection: _ctx.selectedCatalogFunctionItems,
    "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedCatalogFunctionItems = $event)),
    filters: _ctx.filters,
    "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
    class: "p-datatable-sm kn-table",
    dataKey: "id",
    paginator: true,
    rows: 10,
    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
    rowsPerPageOptions: [10, 15, 20],
    responsiveLayout: "stack",
    breakpoint: "960px",
    currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
    globalFilterFields: ['name', 'type', 'tags']
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.filters['global'].value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
            placeholder: _ctx.$t('common.search'),
            badge: "0"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    empty: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    loading: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
    ]),
    default: _withId(() => [
      _createVNode(_component_Column, {
        selectionMode: "multiple",
        exportable: false,
        style: _ctx.importExportDescriptor.export.catalogFunction.column.selectionMode.style
      }, null, 8, ["style"]),
      _createVNode(_component_Column, {
        field: "name",
        header: _ctx.$t(_ctx.importExportDescriptor.export.catalogFunction.column.name.header),
        sortable: true,
        style: _ctx.importExportDescriptor.export.catalogFunction.column.name.style
      }, null, 8, ["header", "style"]),
      _createVNode(_component_Column, {
        field: "type",
        header: _ctx.$t(_ctx.importExportDescriptor.export.catalogFunction.column.type.header),
        sortable: true,
        style: _ctx.importExportDescriptor.export.catalogFunction.column.type.style
      }, null, 8, ["header", "style"]),
      _createVNode(_component_Column, {
        field: "tags",
        header: _ctx.$t(_ctx.importExportDescriptor.export.catalogFunction.column.tags.header),
        sortable: true,
        style: _ctx.importExportDescriptor.export.catalogFunction.column.tags.style
      }, {
        body: _withId(({data}) => [
          _createVNode("span", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_Tag, {
                class: "importExportTags p-mr-1",
                key: index,
                rounded: "",
                value: tag
              }, null, 8, ["value"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["header", "style"])
    ]),
    _: 1
  }, 8, ["value", "selection", "filters", "currentPageReportTemplate"]))
})